import React from 'react';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import device from 'evcharging/assets/open-adr/device.png';
import deviceMobile from 'evcharging/assets/open-adr/deviceMobile.png';
import { Theme } from 'evcharging/app/themes';

const YourCar = () => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return <div className={styles.root} />;
};

const createStyles = (theme: Theme) => ({
  root: css`
    background: #f6f8f9 url('${device}') center no-repeat;
    background-size: contain;
    height: 450px;

    ${theme.breakpoints.mobile.down} {
      background: #f6f8f9 url('${deviceMobile}') center no-repeat;
      height: 685px;
    }
  `,
});

export default YourCar;
